import React from "react";

const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93992 9.12553C2.33325 10.2304 2.33325 11.5662 2.33325 14.2355V16.0112C2.33325 20.5612 2.33325 22.8374 3.70059 24.2514C5.06792 25.6654 7.26709 25.6654 11.6666 25.6654H16.3333C20.7328 25.6654 22.9331 25.6654 24.2993 24.2514C25.6654 22.8374 25.6666 20.5624 25.6666 16.0112V14.2367C25.6666 11.5662 25.6666 10.2315 25.0599 9.12553C24.4556 8.01836 23.3484 7.33236 21.1353 5.95803L18.8019 4.5102C16.4628 3.0577 15.2926 2.33203 13.9999 2.33203C12.7073 2.33203 11.5383 3.0577 9.19792 4.5102L6.86459 5.95803C4.65142 7.33236 3.54542 8.01836 2.93992 9.12553ZM13.1249 20.9987C13.1249 21.2308 13.2171 21.4533 13.3812 21.6174C13.5453 21.7815 13.7679 21.8737 13.9999 21.8737C14.232 21.8737 14.4545 21.7815 14.6186 21.6174C14.7827 21.4533 14.8749 21.2308 14.8749 20.9987V17.4987C14.8749 17.2666 14.7827 17.0441 14.6186 16.88C14.4545 16.7159 14.232 16.6237 13.9999 16.6237C13.7679 16.6237 13.5453 16.7159 13.3812 16.88C13.2171 17.0441 13.1249 17.2666 13.1249 17.4987V20.9987Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HomeIcon;
